import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContractorSettings } from '@umss/shared/data-access';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private readonly apiUrl = '/api/contractor/settings';

  constructor(private http: HttpClient) { }

  getSettings(): Observable<ContractorSettings> {
    return this.http.get<ContractorSettings>(this.apiUrl);
  }

  updatePaySettings(settings: { preferredPay: number; urgentPay: number }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/pay`, settings);
  }

  updateFacilitySettings(settings: { preferredFacilities: string[] }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/facilities`, settings);
  }

  updateAlertSettings(settings: { alerts: any }): Observable<void> { // Consider a specific model for alerts
    return this.http.post<void>(`${this.apiUrl}/alerts`, settings);
  }

  updateAvailabilitySettings(settings: { availability: any }): Observable<void> { // Consider a specific model for availability
    return this.http.post<void>(`${this.apiUrl}/availability`, settings);
  }
}
